<template>
  <div class="custom-page-box">
    <a-card title="我的服务">
      <a-form>
        <search-header :col="3">
          <search-list>
            <a-form-item label="服务分类" v-bind="searchItemLayout">
              <a-select
                style="width: 100%"
                v-model="queryParams.serviceCategoryId"
                placeholder="请选择" allowClear
              >
                <a-select-option v-for="(item,index) in serviceCategoryList" :key="index" :value="item.id">{{
                    item.name
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="应用名称" v-bind="searchItemLayout">
              <a-input v-model="queryParams.serverName" placeholder="请输入"></a-input>
            </a-form-item>
            <a-form-item style="margin-left:20px;">
              <a-button type="primary" @click="searchBtn">查询</a-button>
            </a-form-item>
          </search-list>
        </search-header>
      </a-form>
      <a-tabs style="background-color: white;" v-model="activeKey" @change="callback">
        <a-tab-pane tab="可使用" :key="0">
          <ServiceListComponent :firstCall="false" :load-promise="loadPromise" ref="table_1"
                                @onItemClick="onItemClickEvent"></ServiceListComponent>
        </a-tab-pane>
        <a-tab-pane tab="已过期" :key="1">
          <ServiceListComponent :load-promise="loadPromise" ref="table_2"></ServiceListComponent>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import ServiceListComponent from './components/ServiceListComponent'
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'MyService',
  components: { ServiceListComponent },
  mixins: [searchForm],
  data() {
    return {
      activeKey: 0,
      queryParams: {
        platformId: this.getPlatformConfig().platformId,
        overdueStatus: 0,// 0:没过期 1:已过期
        merchantId: this.$store.getters.userInfo.superiorBossId
      },
      loadPromise: params => this.getMyServerListPromise(params),
      serviceCategoryList: []
    }
  },
  mounted() {
    this.getLogUtils().logWithTag('this. getPlatformConfig()==', this.getPlatformConfig())
    this.getServiceCategoryList()
    this.getDetail()
  },
  methods: {
    getDetail() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId
      }
      this.getHttpServices().getUserService().get('api/v2/merchant/detail', params)
        .then(res => {
          this.queryParams.merchantType = res.merchantType
          this.queryParams.saleProductList = res.saleProductList
          const tableKey = this.queryParams.overdueStatus === 0 ? 'table_1' : 'table_2'
          if (this.$refs[tableKey]) {
            this.$refs[tableKey].refresh(true)
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    searchBtn() {
      const tableKey = this.queryParams.overdueStatus === 0 ? 'table_1' : 'table_2'
      if (this.$refs[tableKey]) {
        this.$refs[tableKey].refresh()
      }
    },
    getServiceCategoryList() {
      this.getHttpServices().getServerApiService().post('serviceCategory/getList?pageNum=1&pageSize=1000', {})
        .then(res => {
          this.serviceCategoryList = res.data.filter(item => item.status == 1)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    getMyServerListPromise(params) {
      this.getLogUtils().logWithTag('====params======', params)
      let queryParams = {
        limitDto: {
          ...params
        },
        ...this.queryParams
      }
      return this.getHttpServices().getServerApiService().post('service/selectMyServerList', queryParams)
    },
    callback(key) {
      this.getLogUtils().logWithTag('onOrderChange', key)
      this.queryParams.overdueStatus = key
      const tableKey = key === 0 ? 'table_1' : 'table_2'
      if (this.$refs[tableKey]) {
        this.$refs[tableKey].refresh()
      }
    },
    onItemClickEvent(item) {
      let Logistics = this.$router.resolve({
        name: item.serverRouteName,
        query: {
          serverId: item.serverId,
          serverUniqueId: item.serverUniqueId
        }
      })
      sessionStorage.setItem('menuKey', item.serverRouteName)
      window.open(Logistics.href, '_blank')
    }
  }
}
</script>
<style lang="less">
@import "../CustomPage";
</style>